<template>
  <section class="comparison">
      <div class="comparison--box">
          <div class="comparison--text">
              <h2>
                  Popular comparisons 
              </h2>
          </div>
          <div class="featured--cards">
        <div class="featured--card">
          <div class="featured--card--image" style="background: #DAADBB;">
            <svg
              width="61"
              height="62"
              viewBox="0 0 61 62"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="61" height="62" rx="30.5" fill="white" />
              <path
                d="M19.3643 21.1333H16.5223L13.9961 29.0165H15.5186L16.2178 26.8511H19.7139L20.447 29.0165H21.9695L19.3643 21.1333ZM16.6238 25.5993L17.9433 21.528L19.2966 25.5993H16.6238ZM24.0531 29.0277V21.1333H22.6546V29.0277H24.0531ZM27.1358 23.2084V21.1333H25.7374V23.2084H24.8916V24.3024H25.0269C25.0269 24.3024 25.7374 24.3024 25.7374 25.0805V27.5955C25.7374 28.3962 26.3802 29.0277 27.1697 29.0277H28.1283V27.7872H27.5757C27.3388 27.7872 27.1358 27.5842 27.1358 27.3474V25.182C27.1358 24.3475 25.3652 24.3024 25.072 24.3024H28.1283V23.2084H27.1358ZM18.4395 35.171C18.4395 35.171 16.9283 34.8214 16.8832 34.8101C16.3757 34.6748 15.9471 34.4267 15.9471 33.9079C15.9471 33.344 16.6351 32.8816 17.5035 32.8816C18.5636 32.8816 19.1613 33.5357 19.1613 34.1786H20.6387C20.6387 32.8027 19.5673 31.6411 17.5035 31.6411C15.7554 31.6411 14.4698 32.5771 14.4698 33.9192C14.4698 35.3064 15.3494 35.9717 16.6351 36.265C16.6351 36.265 18.1576 36.6146 18.1914 36.6259C18.7779 36.7725 19.2628 37.0657 19.2628 37.6409C19.2628 38.3514 18.3831 38.8025 17.4584 38.7235C16.2065 38.622 15.7441 37.7987 15.7441 37.2123H14.278C14.278 38.498 15.3494 39.919 17.4809 39.9754C19.0824 40.0092 20.7402 39.1295 20.7402 37.6409C20.7402 36.265 19.7929 35.4981 18.4395 35.171ZM24.3338 38.6559C23.4429 38.6559 22.9692 37.81 22.9692 36.8401C22.9692 35.859 23.5557 35.0244 24.3226 35.0244C24.9316 35.0244 25.4165 35.4755 25.5857 36.0958H27.0969C26.8488 34.641 25.6872 33.7839 24.3113 33.7839C22.7662 33.7839 21.4242 35.1372 21.5031 37.0206C21.5708 38.7799 22.8339 39.8851 24.3451 39.8851C25.7548 39.8851 26.8037 38.9491 27.0743 37.6747H25.518C25.394 38.1822 24.9428 38.6559 24.3338 38.6559ZM29.4496 36.3326V36.3665V36.3326ZM31.0511 33.8064C30.194 33.8741 29.4609 34.765 29.4496 36.3326C29.4609 35.5545 29.8105 34.9906 30.6113 34.9906C31.4909 34.9906 31.7729 35.6447 31.7729 36.3665V39.7611H33.1826V35.8928C33.1826 34.5395 32.0661 33.7275 31.0511 33.8064ZM28.0512 31.8666V39.7611H29.4496V31.8666H28.0512ZM36.9783 33.7839C35.4784 33.7839 34.1025 34.9004 34.1025 36.8401C34.1025 38.7799 35.4558 39.8739 36.9783 39.8851C38.5121 39.8739 39.8654 38.7686 39.8654 36.8401C39.8654 34.9004 38.4783 33.7839 36.9783 33.7839ZM36.9783 38.6446C36.234 38.6446 35.5122 38.0581 35.5122 36.8401C35.5122 35.6898 36.2227 35.0357 36.9783 35.0244C37.7452 35.0357 38.4557 35.7011 38.4557 36.8401C38.4557 38.0581 37.7339 38.6446 36.9783 38.6446ZM43.4763 33.7839C41.9763 33.7839 40.6004 34.9004 40.6004 36.8401C40.6004 38.7799 41.9538 39.8739 43.4763 39.8851C45.0101 39.8739 46.3634 38.7686 46.3634 36.8401C46.3634 34.9004 44.9762 33.7839 43.4763 33.7839ZM43.4763 38.6446C42.7319 38.6446 42.0102 38.0581 42.0102 36.8401C42.0102 35.6898 42.7207 35.0357 43.4763 35.0244C44.2432 35.0357 44.9537 35.7011 44.9537 36.8401C44.9537 38.0581 44.2319 38.6446 43.4763 38.6446ZM48.7562 39.7611V31.8666H47.3578V39.7611H48.7562ZM48.7729 27.3054H29.6395V29.0165H48.7729V27.3054Z"
                fill="black"
              />
            </svg>
          </div>
          <router-link to="/bootcampdetails">
          <div class="featured--card--text">
            <h2>Alt School</h2>
            <div class="featured--card--text--star">
              <div class="featured--card--text--star--stars">
                <svg
                  width="56"
                  height="12"
                  viewBox="0 0 56 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6 0L7.34708 4.1459H11.7063L8.17963 6.7082L9.52671 10.8541L6 8.2918L2.47329 10.8541L3.82037 6.7082L0.293661 4.1459H4.65292L6 0Z"
                    fill="#FFC326"
                  />
                  <path
                    d="M17 0L18.3471 4.1459H22.7063L19.1796 6.7082L20.5267 10.8541L17 8.2918L13.4733 10.8541L14.8204 6.7082L11.2937 4.1459H15.6529L17 0Z"
                    fill="#FFC326"
                  />
                  <path
                    d="M28 0L29.3471 4.1459H33.7063L30.1796 6.7082L31.5267 10.8541L28 8.2918L24.4733 10.8541L25.8204 6.7082L22.2937 4.1459H26.6529L28 0Z"
                    fill="#FFC326"
                  />
                  <path
                    d="M39 0L40.3471 4.1459H44.7063L41.1796 6.7082L42.5267 10.8541L39 8.2918L35.4733 10.8541L36.8204 6.7082L33.2937 4.1459H37.6529L39 0Z"
                    fill="#FFC326"
                  />
                  <path
                    d="M50 0L51.3471 4.1459H55.7063L52.1796 6.7082L53.5267 10.8541L50 8.2918L46.4733 10.8541L47.8204 6.7082L44.2937 4.1459H48.6529L50 0Z"
                    fill="#FFC326"
                  />
                </svg>
                <p>5.0 rating</p>
              </div>
              <div class="featured--card--text--star--reviews">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15 14L14.883 14.007C14.6598 14.0333 14.4519 14.1341 14.293 14.293C14.1341 14.4519 14.0333 14.6598 14.007 14.883L14 15V21H3.998C3.73402 21.0005 3.48062 20.8962 3.29349 20.71C3.10636 20.5239 3.00079 20.271 3 20.007V3.993C3 3.445 3.445 3 3.993 3H20.007C20.555 3 21 3.447 21 3.999V14H15ZM21 16L16 20.997V16H21Z" fill="#A44A65"/>
</svg>
<p>
    250 Reviews
</p>
              </div>
            </div>
          </div>
          </router-link>
        </div>
        <div class="versus">
            <p>
                vs
            </p>
        </div>
         <div class="featured--card">
          <div class="featured--card--image" style="background: #D5A48A;">
            <svg
              width="50"
              height="39"
              viewBox="0 0 50 39"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.4992 2H37.5808L22.0816 24.9729H1L16.4992 2Z"
                fill="white"
              />
              <path
                d="M17.4221 27.1022L11.4189 36.0002H33.5005L48.9997 13.0273H32.7021L23.2061 27.1022H17.4221Z"
                fill="white"
              />
            </svg>
          </div>
          <router-link to="/bootcampdetails">
          <div class="featured--card--text">
            <h2>Alt School</h2>
            <div class="featured--card--text--star">
              <div class="featured--card--text--star--stars">
                <svg
                  width="56"
                  height="12"
                  viewBox="0 0 56 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6 0L7.34708 4.1459H11.7063L8.17963 6.7082L9.52671 10.8541L6 8.2918L2.47329 10.8541L3.82037 6.7082L0.293661 4.1459H4.65292L6 0Z"
                    fill="#FFC326"
                  />
                  <path
                    d="M17 0L18.3471 4.1459H22.7063L19.1796 6.7082L20.5267 10.8541L17 8.2918L13.4733 10.8541L14.8204 6.7082L11.2937 4.1459H15.6529L17 0Z"
                    fill="#FFC326"
                  />
                  <path
                    d="M28 0L29.3471 4.1459H33.7063L30.1796 6.7082L31.5267 10.8541L28 8.2918L24.4733 10.8541L25.8204 6.7082L22.2937 4.1459H26.6529L28 0Z"
                    fill="#FFC326"
                  />
                  <path
                    d="M39 0L40.3471 4.1459H44.7063L41.1796 6.7082L42.5267 10.8541L39 8.2918L35.4733 10.8541L36.8204 6.7082L33.2937 4.1459H37.6529L39 0Z"
                    fill="#FFC326"
                  />
                  <path
                    d="M50 0L51.3471 4.1459H55.7063L52.1796 6.7082L53.5267 10.8541L50 8.2918L46.4733 10.8541L47.8204 6.7082L44.2937 4.1459H48.6529L50 0Z"
                    fill="#FFC326"
                  />
                </svg>
                <p>5.0 rating</p>
              </div>
              <div class="featured--card--text--star--reviews">
             <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15 14L14.883 14.007C14.6598 14.0333 14.4519 14.1341 14.293 14.293C14.1341 14.4519 14.0333 14.6598 14.007 14.883L14 15V21H3.998C3.73402 21.0005 3.48062 20.8962 3.29349 20.71C3.10636 20.5239 3.00079 20.271 3 20.007V3.993C3 3.445 3.445 3 3.993 3H20.007C20.555 3 21 3.447 21 3.999V14H15ZM21 16L16 20.997V16H21Z" fill="#D5A48A"/>
</svg>
<p>
    250 Reviews
</p>
              </div>
            </div>
          </div>
          </router-link>
        </div>
      </div>
         <div class="featured--cards">
        <div class="featured--card">
          <div class="featured--card--image" style="background: #444449;">
            <svg
              width="61"
              height="62"
              viewBox="0 0 61 62"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="61" height="62" rx="30.5" fill="white" />
              <path
                d="M19.3643 21.1333H16.5223L13.9961 29.0165H15.5186L16.2178 26.8511H19.7139L20.447 29.0165H21.9695L19.3643 21.1333ZM16.6238 25.5993L17.9433 21.528L19.2966 25.5993H16.6238ZM24.0531 29.0277V21.1333H22.6546V29.0277H24.0531ZM27.1358 23.2084V21.1333H25.7374V23.2084H24.8916V24.3024H25.0269C25.0269 24.3024 25.7374 24.3024 25.7374 25.0805V27.5955C25.7374 28.3962 26.3802 29.0277 27.1697 29.0277H28.1283V27.7872H27.5757C27.3388 27.7872 27.1358 27.5842 27.1358 27.3474V25.182C27.1358 24.3475 25.3652 24.3024 25.072 24.3024H28.1283V23.2084H27.1358ZM18.4395 35.171C18.4395 35.171 16.9283 34.8214 16.8832 34.8101C16.3757 34.6748 15.9471 34.4267 15.9471 33.9079C15.9471 33.344 16.6351 32.8816 17.5035 32.8816C18.5636 32.8816 19.1613 33.5357 19.1613 34.1786H20.6387C20.6387 32.8027 19.5673 31.6411 17.5035 31.6411C15.7554 31.6411 14.4698 32.5771 14.4698 33.9192C14.4698 35.3064 15.3494 35.9717 16.6351 36.265C16.6351 36.265 18.1576 36.6146 18.1914 36.6259C18.7779 36.7725 19.2628 37.0657 19.2628 37.6409C19.2628 38.3514 18.3831 38.8025 17.4584 38.7235C16.2065 38.622 15.7441 37.7987 15.7441 37.2123H14.278C14.278 38.498 15.3494 39.919 17.4809 39.9754C19.0824 40.0092 20.7402 39.1295 20.7402 37.6409C20.7402 36.265 19.7929 35.4981 18.4395 35.171ZM24.3338 38.6559C23.4429 38.6559 22.9692 37.81 22.9692 36.8401C22.9692 35.859 23.5557 35.0244 24.3226 35.0244C24.9316 35.0244 25.4165 35.4755 25.5857 36.0958H27.0969C26.8488 34.641 25.6872 33.7839 24.3113 33.7839C22.7662 33.7839 21.4242 35.1372 21.5031 37.0206C21.5708 38.7799 22.8339 39.8851 24.3451 39.8851C25.7548 39.8851 26.8037 38.9491 27.0743 37.6747H25.518C25.394 38.1822 24.9428 38.6559 24.3338 38.6559ZM29.4496 36.3326V36.3665V36.3326ZM31.0511 33.8064C30.194 33.8741 29.4609 34.765 29.4496 36.3326C29.4609 35.5545 29.8105 34.9906 30.6113 34.9906C31.4909 34.9906 31.7729 35.6447 31.7729 36.3665V39.7611H33.1826V35.8928C33.1826 34.5395 32.0661 33.7275 31.0511 33.8064ZM28.0512 31.8666V39.7611H29.4496V31.8666H28.0512ZM36.9783 33.7839C35.4784 33.7839 34.1025 34.9004 34.1025 36.8401C34.1025 38.7799 35.4558 39.8739 36.9783 39.8851C38.5121 39.8739 39.8654 38.7686 39.8654 36.8401C39.8654 34.9004 38.4783 33.7839 36.9783 33.7839ZM36.9783 38.6446C36.234 38.6446 35.5122 38.0581 35.5122 36.8401C35.5122 35.6898 36.2227 35.0357 36.9783 35.0244C37.7452 35.0357 38.4557 35.7011 38.4557 36.8401C38.4557 38.0581 37.7339 38.6446 36.9783 38.6446ZM43.4763 33.7839C41.9763 33.7839 40.6004 34.9004 40.6004 36.8401C40.6004 38.7799 41.9538 39.8739 43.4763 39.8851C45.0101 39.8739 46.3634 38.7686 46.3634 36.8401C46.3634 34.9004 44.9762 33.7839 43.4763 33.7839ZM43.4763 38.6446C42.7319 38.6446 42.0102 38.0581 42.0102 36.8401C42.0102 35.6898 42.7207 35.0357 43.4763 35.0244C44.2432 35.0357 44.9537 35.7011 44.9537 36.8401C44.9537 38.0581 44.2319 38.6446 43.4763 38.6446ZM48.7562 39.7611V31.8666H47.3578V39.7611H48.7562ZM48.7729 27.3054H29.6395V29.0165H48.7729V27.3054Z"
                fill="black"
              />
            </svg>
          </div>
          <router-link to="/bootcampdetails">
          <div class="featured--card--text">
            <h2>Alt School</h2>
            <div class="featured--card--text--star">
              <div class="featured--card--text--star--stars">
                <svg
                  width="56"
                  height="12"
                  viewBox="0 0 56 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6 0L7.34708 4.1459H11.7063L8.17963 6.7082L9.52671 10.8541L6 8.2918L2.47329 10.8541L3.82037 6.7082L0.293661 4.1459H4.65292L6 0Z"
                    fill="#FFC326"
                  />
                  <path
                    d="M17 0L18.3471 4.1459H22.7063L19.1796 6.7082L20.5267 10.8541L17 8.2918L13.4733 10.8541L14.8204 6.7082L11.2937 4.1459H15.6529L17 0Z"
                    fill="#FFC326"
                  />
                  <path
                    d="M28 0L29.3471 4.1459H33.7063L30.1796 6.7082L31.5267 10.8541L28 8.2918L24.4733 10.8541L25.8204 6.7082L22.2937 4.1459H26.6529L28 0Z"
                    fill="#FFC326"
                  />
                  <path
                    d="M39 0L40.3471 4.1459H44.7063L41.1796 6.7082L42.5267 10.8541L39 8.2918L35.4733 10.8541L36.8204 6.7082L33.2937 4.1459H37.6529L39 0Z"
                    fill="#FFC326"
                  />
                  <path
                    d="M50 0L51.3471 4.1459H55.7063L52.1796 6.7082L53.5267 10.8541L50 8.2918L46.4733 10.8541L47.8204 6.7082L44.2937 4.1459H48.6529L50 0Z"
                    fill="#FFC326"
                  />
                </svg>
                <p>5.0 rating</p>
              </div>
              <div class="featured--card--text--star--reviews">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15 14L14.883 14.007C14.6598 14.0333 14.4519 14.1341 14.293 14.293C14.1341 14.4519 14.0333 14.6598 14.007 14.883L14 15V21H3.998C3.73402 21.0005 3.48062 20.8962 3.29349 20.71C3.10636 20.5239 3.00079 20.271 3 20.007V3.993C3 3.445 3.445 3 3.993 3H20.007C20.555 3 21 3.447 21 3.999V14H15ZM21 16L16 20.997V16H21Z" fill="#444449"/>
</svg>
<p>
    250 Reviews
</p>
              </div>
            </div>
          </div>
          </router-link>
        </div>
        <div class="versus">
            <p>
                vs
            </p>
        </div>
         <div class="featured--card">
          <div class="featured--card--image" style="background: #DAADBB;">
            <svg
              width="50"
              height="39"
              viewBox="0 0 50 39"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.4992 2H37.5808L22.0816 24.9729H1L16.4992 2Z"
                fill="white"
              />
              <path
                d="M17.4221 27.1022L11.4189 36.0002H33.5005L48.9997 13.0273H32.7021L23.2061 27.1022H17.4221Z"
                fill="white"
              />
            </svg>
          </div>
          <router-link to="/bootcampdetails">
          <div class="featured--card--text">
            <h2>Alt School</h2>
            <div class="featured--card--text--star">
              <div class="featured--card--text--star--stars">
                <svg
                  width="56"
                  height="12"
                  viewBox="0 0 56 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6 0L7.34708 4.1459H11.7063L8.17963 6.7082L9.52671 10.8541L6 8.2918L2.47329 10.8541L3.82037 6.7082L0.293661 4.1459H4.65292L6 0Z"
                    fill="#FFC326"
                  />
                  <path
                    d="M17 0L18.3471 4.1459H22.7063L19.1796 6.7082L20.5267 10.8541L17 8.2918L13.4733 10.8541L14.8204 6.7082L11.2937 4.1459H15.6529L17 0Z"
                    fill="#FFC326"
                  />
                  <path
                    d="M28 0L29.3471 4.1459H33.7063L30.1796 6.7082L31.5267 10.8541L28 8.2918L24.4733 10.8541L25.8204 6.7082L22.2937 4.1459H26.6529L28 0Z"
                    fill="#FFC326"
                  />
                  <path
                    d="M39 0L40.3471 4.1459H44.7063L41.1796 6.7082L42.5267 10.8541L39 8.2918L35.4733 10.8541L36.8204 6.7082L33.2937 4.1459H37.6529L39 0Z"
                    fill="#FFC326"
                  />
                  <path
                    d="M50 0L51.3471 4.1459H55.7063L52.1796 6.7082L53.5267 10.8541L50 8.2918L46.4733 10.8541L47.8204 6.7082L44.2937 4.1459H48.6529L50 0Z"
                    fill="#FFC326"
                  />
                </svg>
                <p>5.0 rating</p>
              </div>
              <div class="featured--card--text--star--reviews">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15 14L14.883 14.007C14.6598 14.0333 14.4519 14.1341 14.293 14.293C14.1341 14.4519 14.0333 14.6598 14.007 14.883L14 15V21H3.998C3.73402 21.0005 3.48062 20.8962 3.29349 20.71C3.10636 20.5239 3.00079 20.271 3 20.007V3.993C3 3.445 3.445 3 3.993 3H20.007C20.555 3 21 3.447 21 3.999V14H15ZM21 16L16 20.997V16H21Z" fill="#A44A65"/>
</svg>
<p>
    250 Reviews
</p>
              </div>
            </div>
          </div>
          </router-link>
        </div>
      </div>
      </div>
  </section>
</template>

<script>
export default {

}
</script>

<style scoped lang="scss">
@import "@/styles/_mixins.scss";
@import "@/styles/_variables.scss";
@import "@/styles/_typography.scss";
.comparison {
    padding: 1rem 7% 3rem 7%;
}
.comparison--text {
    max-width: 100vw;
    width: min(90%, 459px);
    margin: 0 auto;
    text-align: center;
    h2 {
        @include details {
           color: #B86B41;
           font-family: $karla;
        }
    }
}
.featured--cards {
    @include flex(space-between, center);
    width: min(1134px, 90%);
    margin: 2.2rem auto;
}
.featured--card {
    width: min(90%, 417px);
    @include flex(center, center);
    height: 196px;
    margin: 1rem 0;
    .featured--card--image {
        width: 176px;
        height: 196px;
        background: #8F3D55;
        border-radius: 8px 0px 0px 8px;
        @include flex(center, center);
    }
}
.featured--card--text {
    text-align: center;
    background: rgba(240, 222, 213, 0.4);
    height: 196px;
    width: 221px;
    margin: 0 auto;
    border-radius: 0px 8px 8px 0px;
    padding: 2rem;
    h2 {
        width: 100%;
        @include body-bold {
            color: $black-100;
            font-family: $karla;
        }
    }
}
.featured--card--text--star {
    margin: 2rem auto;
    width: 100%;
    @include flex(flex-start, center);
    flex-direction: column;
    gap: 1.5rem;
    .featured--card--text--star--stars {
        @include flex(center, center);
        gap: 0.2rem;
        p {
            align-self: center;
            margin: auto;
            @include label {
                color: $gray-100;
                font-family: $karla;
            }
        }
        svg {
             align-self: center;
             margin: auto;
        }
    }
    .featured--card--text--star--reviews {
        @include flex(flex-start, center);
        p {
            align-self: center;
            height:24px;
            margin: auto 0 auto 0;
            /* margin-right: 1rem; */
            @include caption {
                color: $black-100;
                font-family: $karla;
            }
        }
        svg {
             align-self: center;
             margin: auto;
        }
    }
}
.versus {
    p {
        @include details {
            font-family: $karla;
            color: #B86B41;
        }
    }
}
@include xl {
  .featured--cards {
   flex-direction: column;
}
.featured--card {
    .featured--card--image {
        width: 176px;
        height: 196px;
        background: #8F3D55;
        border-radius: 8px 0px 0px 8px;
        @include flex(center, center);
    }
}
.featured--card--text {
    text-align: center;
    background: rgba(240, 222, 213, 0.4);
    height: 196px;
    width: 221px;
    margin: 0 auto;
    border-radius: 0px 8px 8px 0px;
    padding: 2rem;
    h2 {
        width: 100%;
        @include body-bold {
            color: $black-100;
            font-family: $karla;
        }
    }
}
}
@include xs {
  .comparison--text {
    h2 {
        @include details {
           font-size: 1.6rem;
        }
    }
}
}
</style>